const GreenCheckBadgeIcon = () => {
  return (
    <svg
      width='100'
      height='100'
      viewBox='0 0 100 100'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='100' height='100' rx='20' fill='#3B7CF4' fillOpacity='0.1' />
      <path
        d='M46.0556 62.9445C44.8283 64.1718 42.8384 64.1718 41.6111 62.9445L32.8333 54.1667C31.5447 52.878 31.5447 50.7887 32.8333 49.5C34.122 48.2113 36.2113 48.2113 37.5 49.5L42.3889 54.3889C43.1866 55.1866 44.48 55.1866 45.2778 54.3889L63.5 36.1667C64.7887 34.878 66.878 34.878 68.1667 36.1667C69.4553 37.4553 69.4553 39.5447 68.1667 40.8333L46.0556 62.9445Z'
        fill='#3B7CF4'
      />
    </svg>
  );
};

export default GreenCheckBadgeIcon;
